export default __webpack_public_path__ + "static/media/Connexion.d473874e.png";